import React from 'react';
import { useTranslation } from 'react-i18next';
import { GovSkeleton } from '@gov-design-system-ce/react';
import { LocalizeNameSpaceTypes } from '@gov-nx/core/service';
import { ContentLayout, LayoutGap } from '@gov-nx/ui/web';
import { generateRandomNumber } from '@gov-nx/utils/common';

export const MySubmissionsMessageSkeleton = () => {
	const { t } = useTranslation(LocalizeNameSpaceTypes.Global);
	return (
		<LayoutGap className="md:ml-2!">
			<div className="flex flex-col [ md:flex-row ]">
				<div className="w-1/2">
					<GovSkeleton
						width="60px"
						height="22px"
						aria-label={t('loading.wcag.processing', {
							namespace: LocalizeNameSpaceTypes.Global,
						})}
					/>
				</div>
				<GovSkeleton
					width={generateRandomNumber(150, 300) + 'px'}
					height="22px"
					aria-label={t('loading.wcag.processing', {
						namespace: LocalizeNameSpaceTypes.Global,
					})}
				/>
			</div>
			<div className="flex flex-col [ md:flex-row ]">
				<div className="w-1/2">
					<GovSkeleton
						width="130px"
						height="22px"
						aria-label={t('loading.wcag.processing', {
							namespace: LocalizeNameSpaceTypes.Global,
						})}
					/>
				</div>
				<GovSkeleton
					width="80px"
					height="22px"
					aria-label={t('loading.wcag.processing', {
						namespace: LocalizeNameSpaceTypes.Global,
					})}
				/>
			</div>
			<GovSkeleton
				width="150px"
				height="22px"
				aria-label={t('loading.wcag.processing', {
					namespace: LocalizeNameSpaceTypes.Global,
				})}
				className="mt-1! mb-(--templates-margin-xl)!"
			/>
			<GovSkeleton
				width="270px"
				height="56px"
				aria-label={t('loading.wcag.processing', {
					namespace: LocalizeNameSpaceTypes.Global,
				})}
			/>
		</LayoutGap>
	);
};

export const MySubmissionsDetailSkeleton = () => {
	const { t } = useTranslation(LocalizeNameSpaceTypes.Global);
	return (
		<LayoutGap gap="3xl">
			<LayoutGap gap="s">
				<GovSkeleton
					width="200px"
					height="20px"
					aria-label={t('loading.wcag.processing', {
						namespace: LocalizeNameSpaceTypes.Global,
					})}
					className="skeleton-brighter"
				/>
				<GovSkeleton
					width="180px"
					height="20px"
					aria-label={t('loading.wcag.processing', {
						namespace: LocalizeNameSpaceTypes.Global,
					})}
					className="skeleton-brighter"
				/>
				<GovSkeleton
					width="170px"
					height="20px"
					aria-label={t('loading.wcag.processing', {
						namespace: LocalizeNameSpaceTypes.Global,
					})}
					className="skeleton-brighter"
				/>
			</LayoutGap>
			<GovSkeleton
				width="140px"
				height="38px"
				aria-label={t('loading.wcag.processing', {
					namespace: LocalizeNameSpaceTypes.Global,
				})}
				className="skeleton-brighter"
			/>
			<ContentLayout>
				<GovSkeleton
					width="240px"
					height="30px"
					aria-label={t('loading.wcag.processing', {
						namespace: LocalizeNameSpaceTypes.Global,
					})}
				/>
			</ContentLayout>
		</LayoutGap>
	);
};
